$(document).ready(function () {
    const hidden = $('.in-hide');
    $(document).on('scroll', () => {
        hidden.each(function () {
            const element = $(this);
            if (element.visible(true) && element.hasClass('in-hide')) element.removeClass('in-hide');
        });
    });
});